import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import CheckIcon from '@mui/icons-material/Check';
import IconButton from '@mui/material/IconButton';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Translate } from '../../../../../shared/LanguageService';

export type Outlier = {
    id: number;
    amount: number;
    photographerName: string;
    photographerId: string;
    productName: string;
    orderRowId: number;
    orderUrl: string;
    hasBeenReviewed: boolean;
};

type OutlierRowProps = {
    outlier: Outlier;
    index: number;
    onClickMarkAsReviewed: (id: number) => Promise<void>;
};

let isEven = (i: number) => i % 2 === 0;

export function OutlierRow({ outlier, onClickMarkAsReviewed, index }: OutlierRowProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                backgroundColor: isEven(index) ? '#f5f5f5' : '#fff',
                cursor: 'pointer',
                padding: '0 4px'
            }}
        >
            <Typography
                sx={{
                    fontSize: '14px'
                }}
            >
                {outlier.photographerName},
            </Typography>
            <Typography
                sx={{
                    fontSize: '14px',
                    fontWeight: 700
                }}
            >
                {outlier.productName}
            </Typography>
            <Typography
                sx={{
                    fontSize: '14px',
                    fontWeight: 700,
                    flex: '1 auto'
                }}
            >
                {outlier.amount}:-
            </Typography>
            <a href={outlier.orderUrl} target="_blank" rel="noopener noreferrer">
                <Tooltip
                    title={Translate(
                        'economy/photographer-invoice-collection/pending/outliers/to-order-tooltip'
                    )}
                    placement="top-start"
                >
                    <IconButton>
                        <OpenInNewIcon />
                    </IconButton>
                </Tooltip>
            </a>
            <Tooltip
                title={Translate(
                    'economy/photographer-invoice-collection/pending/outliers/mark-done-tooltip'
                )}
                placement="top-start"
            >
                <IconButton
                    onClick={() => {
                        onClickMarkAsReviewed(outlier.id);
                    }}
                >
                    <CheckIcon />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
